'use client';

import React from "react";
import H2HItem from "@/components/H2HItem";
import TabPanel from "@/components/TabPanel";
import NoData from "@/components/NoData";
import HeaderTopRecentMatches from "@/components/HeaderTopRecentMatches";
import CollapsiblePanel from "@/components/CollapsiblePanel";

import { useMatchInfo } from "../ThongTinTranDau/MatchInfoContext";


const MatchLabel = ({ label }) => {
  return (
    <div className="flex items-center bg-[var(--theme-primary)] text-[var(--theme-on-primary)] font-semibold rounded w-full px-3 py-1 text-sm">
      {label}
    </div>
  );
}

const HeadToHead = () => {
  const { matchAnalysis: match } = useMatchInfo();

  if (!match || match.length === 0) {
    return (
      <>
        <MatchLabel label={"Thành tích đối đầu 10 trận gần nhất"} />
        <NoData />
      </>
    );
  }

  const { headToHead, homeLastMatches, awayLastMatches, homeId, awayId } =
    match;

  const home = {
    id: homeId,
    name: match.homeTeam.name,
    logo: match.homeTeam.logo,
  };

  const away = {
    id: awayId,
    name: match.awayTeam.name,
    logo: match.awayTeam.logo,
  };

  return (
    <>
      <CollapsiblePanel
        title="Thành tích đối đầu 10 trận gần nhất"
      >
        {headToHead.length > 0 ? (<TabPanel home={home} away={away} data={headToHead} />) : (
          <NoData message="Không có dữ liệu" />
        )}
      </CollapsiblePanel>
      <CollapsiblePanel
        title="Thành tích 10 trận gần nhất"
      >
        <div className="flex items-center bg-[var(--theme-foreground)] border border-[var(--theme-border)] px-3 py-2 gap-4 my-2 rounded-md text-[var(--theme-text)] text-base font-semibold">
          <div>
            <img
              alt="Net88"
              src={match.homeTeam.logo}
              width={32}
              height={32}
            />
          </div>
          <div>{match.homeTeam.name}</div>
        </div>
        <HeaderTopRecentMatches />
        {homeLastMatches?.length > 0
          ? homeLastMatches.map((item, index) => (
              <H2HItem key={`home-match-${index}`} match={item} />
            ))
          : null}
        <div className="flex items-center rounded-md bg-[var(--theme-foreground)] border border-[var(--theme-border)] px-3 py-2 gap-4 mb-2 mt-4 text-[var(--theme-text)] text-base font-semibold">
          <div>
            <img
              alt="Net88"
              src={match.awayTeam.logo}
              width={32}
              height={32}
            />
          </div>
          <div>{match.awayTeam.name}</div>
        </div>
        <HeaderTopRecentMatches />
        {awayLastMatches?.length > 0
          ? awayLastMatches.map((item, index) => (
              <H2HItem key={`away-match-${index}`} match={item} />
            ))
          : null}
      </CollapsiblePanel>
    </>
  );
};

export default React.memo(HeadToHead);
